import React, { useEffect, useState } from "react";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import custom_getvalue from "../../../../components/main_comps/custom_getvalue";

const Container = ({ title, value, loop = false }) => {
  return (
    <div style={{ display: "flex", marginBottom: "20px" }}>
      <p
        style={{
          color: "#000000",
          fontSize: "14px",
          fontWeight: "500",
          width: "180px",
        }}
      >
        {title}
      </p>
      {loop ? (
        <div style={{ display: "flex" }}>
          {value?.map((service, index) => {
            return <></>;
          })}
        </div>
      ) : (
        <p style={{ color: "#3A3A3A", fontSize: "14px" }}>{value}</p>
      )}
    </div>
  );
};
const inputStyle = {
  backgroundColor: "#F3F3F3",
  alignSelf: "center",
  height: 40,
  boxShadow: "none",
  outline: "none",
  paddingLeft: 10,
  boxSizing: "border-box",
  borderRadius: "5px",
  width: "100%",
};
const containerStyle = {
  padding: 0,
  maxWidth: 300,
  minWidth: "250px",
  width: "100%",
  height: "40px",
};
const BasicDetails = ({ data, isEditClicked = false, onChange }) => {
  const [customerName, setCustomerName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [upi, setUpi] = useState("");
  const [type, setType] = useState("");

  const handleData = () => {
    if (!isEditClicked) {
      setCustomerName(data?.customerName);
      setMobileNumber(data?.mobileNumber);
      setUpi(data?.upi);
      setEmail(data?.email);
      setType(data?.type);
    }
  };
  useEffect(() => {
    handleData();
  }, [isEditClicked]);

  useEffect(() => {
    onChange({
      customerName: custom_getvalue(customerName, data?.customerName),
      email: custom_getvalue(email, data?.email),
      mobileNumber: custom_getvalue(mobileNumber, data?.mobileNumber),
      upi: custom_getvalue(upi, data?.upi),
      type: custom_getvalue(type, data?.type),
    });
  }, [customerName, email, mobileNumber, upi, type]);

  return (
    <div
      style={{
        padding: "10px 20px",
        flexWrap: "wrap",
        display: "flex",
        flexDirection: "row",
      }}
    >
      {isEditClicked ? (
        <>
          <div style={{ width: "50%", minWidth: "400px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"Customer Name"}
              </p>
              <CustomInput
                value={customerName}
                onChange={(data) => setCustomerName(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Customer Name"
                validator="bankName"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"Email Id"}
              </p>
              <CustomInput
                value={email}
                onChange={(data) => setEmail(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Email id"
                validator="email"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"Mobile Number"}
              </p>
              <CustomInput
                value={mobileNumber}
                onChange={(data) => setMobileNumber(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Mobile number"
                validator="mobile"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"UPI"}
              </p>
              <CustomInput
                value={upi}
                onChange={(data) => setUpi(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="UPI"
                validator="upi"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <p
                style={{
                  color: "#000000",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "180px",
                }}
              >
                {"Type"}
              </p>
              <CustomInput
                value={type}
                onChange={(data) => setType(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Type"
                validator="alphaNumeric"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <div style={{ width: "50%", minWidth: "400px" }}>
            <Container title="Name:" value={data?.customerName} />
            <Container title="Email ID:" value={data?.email} />
            <Container
              title="Mobile Number:"
              value={"+91 " + data?.mobileNumber}
            />
            <Container title="UPI:" value={data?.upi} />
            <Container title="Type:" value={data?.type} />
          </div>
        </>
      )}
    </div>
  );
};

export default BasicDetails;
